import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

export const CORE_MODULES = [CommonModule, FormsModule, TranslateModule, ReactiveFormsModule];
